var render, staticRenderFns
import script from "./propView.vue?vue&type=script&lang=js&"
export * from "./propView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153bf384",
  null
  
)

export default component.exports